import { createRouter, createWebHistory } from 'vue-router';
import { authGuard } from './guards';

// Eager loaded components (critical path)
import Login from '@/views/Login.vue';
import LandingPage from '@/views/LandingPage.vue';
import AuthCallback from '@/views/AuthCallback.vue';

const routes = [
  {
    path: '/login',
    name: 'LoginPage',
    component: Login
  },
  {
    path: '/auth/callback',
    name: 'AuthCallback',
    component: AuthCallback
  },
  {
    path: '/',
    name: 'Landing',
    component: LandingPage,
  },
  {
    path: '/admin',
    name: 'AdminPanel',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/AdminPanel.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/subscription',
    name: 'Subscription',
    component: () => import(/* webpackChunkName: "subscription" */ '@/views/SubscriptionPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/portfolios',
    name: 'Portfolios',
    component: () => import(/* webpackChunkName: "dashboard" */ '@/views/PortfolioPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/net-worth',
    name: 'NetWorth',
    component: () => import(/* webpackChunkName: "dashboard" */ '@/views/NetWorthPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/liabilities',
    name: 'Liabilities',
    component: () => import(/* webpackChunkName: "dashboard" */ '@/views/LiabilitiesView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/custom-symbols',
    name: 'CustomSymbols',
    component: () => import(/* webpackChunkName: "dashboard" */ '@/views/CustomSymbolsPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/market',
    name: 'Market',
    component: () => import(/* webpackChunkName: "dashboard" */ '@/views/MarketPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/transactions/:id',
    name: 'Transactions',
    component: () => import(/* webpackChunkName: "transactions" */ '@/views/TransactionsPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/portfolio/:id/details',
    name: 'PortfolioDetails',
    component: () => import(/* webpackChunkName: "portfolio-details" */ '@/views/PortfolioDetailsPage.vue'),
    meta: { requiresAuth: true }
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// Apply the authentication guard to every route
router.beforeEach(authGuard);

export default router;
